import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

// No scope means the whole org (owners); otherwise the rep must sit on one of the viewer's teams.
const isUserInTeamScope = (user: User, scopeTeamIds: Set<Team["id"]> | undefined): boolean =>
  !scopeTeamIds || user.teams.some(({ id }) => scopeTeamIds.has(id));

export default isUserInTeamScope;
